import { createContext} from 'react'

interface AuthContextProps {
    authToken: string | null
    setAuthToken: React.Dispatch<React.SetStateAction<string | null>>
}

export const AuthContext = createContext<AuthContextProps | null> (null);

